import { Repository } from "src/firebase/firestore/repository";
import { Organization, Project } from "./types/organization.entity";
import { getDoc, collection, getDocs } from "firebase/firestore";
import { db } from "src/firebase";

export class OrganizationRepository extends Repository<Organization> {
  constructor() {
    super("organizations");
  }

  async getOrganizationProjects(orgId: string) {
    const projects = await getDocs(collection(db, "organizations", orgId, "projects"));

    return projects.docs.map((doc) => this.mapTo<Project>(doc));
  }
}

export const organizationRepository = new OrganizationRepository();
